import React, { Suspense } from 'react';
import './App.css';
import {BrowserRouter, Switch, Route, Redirect} from 'react-router-dom'
import { Spin } from 'antd';

const DefaultLayout = React.lazy(() => import('./containers/DefaultLayout'));
const Login = React.lazy(() => import('./containers/Login'));

function App() {
  return (
    <Suspense 
      fallback={
        <div className="loading-component text-center">
          <Spin style={{position:"absolute", top:"40%"}} size="large" tip="Loading..."/>
        </div>
      }
    >
      <BrowserRouter>
        <Switch>
          <Redirect exact from= "/" to="/login" />
          <Route exact path="/login" component={Login} />
          <Route path="/:locale" component={DefaultLayout} />
        </Switch>
      </BrowserRouter>
    </Suspense>
  );
}

export default App;
